import { cx } from "@emotion/css";
import { ThreadVisibility } from "libs/schema";
import { RefObject } from "react";
import { IComposeMessageForm } from "~/components/ComposeMessageContext";
import { ThreadRecipients, TThreadRecipientsRef } from "~/components/forms/ThreadRecipients";
import { useControlState } from "~/components/forms/utils";
import { useCurrentUserSettings } from "~/hooks/useCurrentUserSettings";
import { Subject } from "../utils";
import { ParentComponent } from "~/utils/type-helpers";

export const HeaderFields: ParentComponent<{
  control: IComposeMessageForm;
  visibility: ThreadVisibility | null;
  toRecipientsRef: RefObject<TThreadRecipientsRef>;
  contentTopRef: RefObject<HTMLDivElement>;
}> = (props) => {
  const { control, visibility, toRecipientsRef, contentTopRef } = props;

  const threadType = useControlState(() => props.control.rawValue.type, [props.control]);

  const isToInvalid = useControlState(() => !props.control.controls.recipients.controls.to.isValid, [props.control]);

  const isToTouched = useControlState(() => props.control.controls.recipients.controls.to.isTouched, [props.control]);

  const isCcInvalid = useControlState(() => !props.control.controls.recipients.controls.cc.isValid, [props.control]);

  const isCcTouched = useControlState(() => props.control.controls.recipients.controls.cc.isTouched, [props.control]);

  const { settings } = useCurrentUserSettings();

  const isEmailEnabled = settings?.linked_gmail_email_account === true;

  return (
    <>
      <div className="flex items-baseline mx-4 py-2 border-b border-slate-6">
        <label htmlFor="to" className={cx("mr-2 font-medium", isToTouched && isToInvalid && "text-red-9")}>
          To
        </label>

        <ThreadRecipients
          ref={toRecipientsRef}
          control={control.controls.recipients.controls.to}
          name="to"
          wrapperClassName="flex-1"
          autoFocus
          threadType={threadType}
          canAddEmailRecipients={isEmailEnabled}
          isThreadPrivate={visibility === null ? null : visibility === "PRIVATE"}
        />
      </div>

      {threadType === "EMAIL" && (
        <div className="flex items-baseline mx-4 py-2 border-b border-slate-6">
          <label htmlFor="cc" className={cx("mr-2 font-medium", isCcInvalid && isCcTouched && "text-red-9")}>
            Cc
          </label>

          <ThreadRecipients
            name="cc"
            control={control.controls.recipients.controls.cc}
            wrapperClassName="flex-1"
            threadType={threadType}
            canAddEmailRecipients={isEmailEnabled}
            isThreadPrivate={visibility === null ? null : visibility === "PRIVATE"}
          />
        </div>
      )}

      <div ref={contentTopRef}>
        <div className="flex items-center mx-4 py-2 border-b border-slate-6">
          <Subject control={control.controls.subject} />
        </div>
      </div>
    </>
  );
};
